import { Container, Card, CardBody, Nav, NavItem, NavLink } from "shards-react";
import { NavLink as RouteNavLink } from "react-router-dom";
import PageTitle from "./PageTitle";
import classNames from "classnames";
import {
  ADMIN_TOOLS_WRAPPER,
  QR_CODE_WRAPPER,
  UPLOAD_DOCUMENT_WRAPPER,
  DOWNLOAD_DOCTYPES_WRAPPER,
  CREATE_ENVELOPE_WRAPPER,
} from "utils/constants.json";

/**
 * Exporting Tab Component that receives as a props:
 * title, subtitle, tabs, defaultPath, children.
 * So the content can be rendered in different tabs.
 */

const TabsMenu = ({
  title,
  subtitle,
  tabs,
  defaultPath,
  children,
  pageTitle,
  align,
  serviceType,
}) => {
  const classes = classNames(align);

  return (
    <Container
      fluid
      className="main-content-container p-2 d-grid template-rows-auto-fr template-rows-md-auto"
    >
      <PageTitle
        title={title}
        subtitle={subtitle}
        className={pageTitle}
        serviceType={serviceType}
      />
      <Card className={classes}>
        <Nav tabs className="align-items-center">
          {tabs.map((tab, index) => (
            <NavItem key={index} className="m-0">
              <NavLink
                tag={RouteNavLink}
                to={`${defaultPath}/${index}`}
                className="pointer tab-text"
              >
                {tab}
              </NavLink>
            </NavItem>
          ))}
          <div id={ADMIN_TOOLS_WRAPPER} className="ml-auto"></div>
          <div id={DOWNLOAD_DOCTYPES_WRAPPER}></div>
          <div id={UPLOAD_DOCUMENT_WRAPPER}></div>
          <div id={CREATE_ENVELOPE_WRAPPER}></div>
          <div id={QR_CODE_WRAPPER}></div>
          <div className="mr-3"></div>
        </Nav>
        <CardBody className="p-0">{children}</CardBody>
      </Card>
    </Container>
  );
};

export default TabsMenu;
